import { __awaiter, __generator, __read } from "tslib";
import { createTokenManager } from '@hose/idp-jslib';
import { useFetchInstance, Fetch, configure, } from '@ekuaibao/fetch';
var isPro = window.location.origin.includes('ekuaibao.com');
var SUITE_ID_DEV = 'wwafcaadcea40e9595';
var SUITE_ID_PRO = 'wwa3e60352e71e0128';
export var getWecomServerDomain = function () {
    var getByCurrentDomain = function () {
        var host = 'https://wecom.ekuaibao.net';
        if (isPro) {
            host = 'https://wecom.hosecloud.com';
        }
        return host;
    };
    if (!window.ENV_CONFIG) {
        return getByCurrentDomain();
    }
    return window.ENV_CONFIG['wecomServerDomain'] || getByCurrentDomain();
};
var WECOM_SERVER_HOSTNAME = getWecomServerDomain();
var SUITE_ID = window.ENV_CONFIG['wecomISVSuiteId'] || (isPro ? SUITE_ID_PRO : SUITE_ID_DEV);
var appendQuery = function (queryList) {
    var url = new URL(window.location.href);
    queryList.forEach(function (item) {
        url.searchParams.set(item.key, item.value);
    });
    window.history.replaceState(null, '', url.toString());
};
var getCodeOfQuery = function () {
    var qs = new URLSearchParams(window.location.search);
    return qs.get('code');
};
var redirectToAuthUrl = function (url) {
    var redirect_uri = encodeURI(url || window.location.href);
    var login_url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + SUITE_ID + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    window.location.href = login_url;
};
var getIDPInfo = function (code) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, window.fetch(WECOM_SERVER_HOSTNAME + "/api/wecom/public/oauth/login?code=" + encodeURIComponent(code), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    keepalive: false,
                })];
            case 1:
                res = _a.sent();
                return [2, res.json()];
        }
    });
}); };
var idpInfo = {
    clientId: 'whispered-app',
    idpBaseUri: location.origin.includes('release.ekuaibao.net')
        ? 'https://idp.ekuaibao.net'
        : 'https://idp.hosecloud.com'
};
export var getSignature = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, fetch(WECOM_SERVER_HOSTNAME + "/api/wecom/public/js-sdk/signature", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        corpId: Fetch.wxCorpId,
                        url: url,
                    })
                })];
            case 1:
                res = _a.sent();
                return [2, res.json()];
        }
    });
}); };
var initTokenManager = function (code) { return __awaiter(void 0, void 0, void 0, function () {
    var tokenManager, fetcher, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                tokenManager = createTokenManager({
                    clientId: idpInfo.clientId,
                    idpBaseUri: idpInfo.idpBaseUri,
                    enableCORS: true,
                    fetch: useFetchInstance(),
                    onTokenChange: function (token) {
                        Fetch.accessToken = encodeURIComponent(token);
                    }
                });
                return [4, tokenManager.finishLogin(code)];
            case 1:
                _a.sent();
                fetcher = tokenManager.decorateFetch(useFetchInstance());
                configure({ fetcher: fetcher, appendAccessTokenToQuery: false });
                return [3, 3];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                throw error_1;
            case 3: return [2];
        }
    });
}); };
export var loginInit = function () { return __awaiter(void 0, void 0, void 0, function () {
    var code, options, access_token, hoseCorpId, wecomCorpId, url, _a, _, signatureInfo;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                code = getCodeOfQuery();
                if (!code) return [3, 3];
                return [4, getIDPInfo(code)];
            case 1:
                options = _b.sent();
                access_token = options.access_token, hoseCorpId = options.hoseCorpId, wecomCorpId = options.wecomCorpId;
                if (!access_token && hoseCorpId === 'INVALID_CODE') {
                    url = new URL(window.location.href);
                    url.searchParams.delete('code');
                    redirectToAuthUrl(url.toString());
                }
                Fetch.corpId = hoseCorpId;
                Fetch.wxCorpId = wecomCorpId;
                Fetch.ekbCorpId = hoseCorpId;
                appendQuery([{ key: 'corpId', value: hoseCorpId }]);
                return [4, Promise.all([initTokenManager(access_token), getSignature(location.href)])];
            case 2:
                _a = __read.apply(void 0, [_b.sent(), 2]), _ = _a[0], signatureInfo = _a[1];
                return [2, { options: options, signatureInfo: signatureInfo }];
            case 3:
                redirectToAuthUrl();
                _b.label = 4;
            case 4: return [2];
        }
    });
}); };
